import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Backspace = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M19.5,5 L8.25,5 C7.7325,5 7.3275,5.2625 7.0575,5.66 L3,11.75 L7.0575,17.8325 C7.3275,18.23 7.7325,18.5 8.25,18.5 L19.5,18.5 C20.325,18.5 21,17.825 21,17 L21,6.5 C21,5.675 20.325,5 19.5,5 Z M17.25,14.4425 L16.1925,15.5 L13.5,12.8075 L10.8075,15.5 L9.75,14.4425 L12.4425,11.75 L9.75,9.0575 L10.8075,8 L13.5,10.6925 L16.1925,8 L17.25,9.0575 L14.5575,11.75 L17.25,14.4425 Z" })));
};
export default Backspace;
